export default {
  meta: {
    label: 'Português (Brasil)'
  },
  data: {
    'pt-BR': {
      97: [
        ['⚓️', 'âncora'],
        ['🍍', 'abacaxi'],
        ['🚑', 'ambulância'],
        ['🐝', 'abelha'],
        ['🥜', 'amendoim'],
        ['🌈', 'Arco-íris'],
        ['✈', 'avião']
      ],
      98: [
        ['🍌', 'banana'],
        ['👶', 'bebê'],
        ['🦋', 'borboleta'],
        ['🥔', 'batata'],
        ['🥦', 'brócolis'],
        ['🥖', 'baguete'],
        ['⛄️', 'Boneco de neve'],
        ['🥓', 'bacon'],
        ['🚲', 'bicicleta'],
        ['🐳', 'Baleia']
      ],
      99: [
        ['🦐', 'camarão'],
        ['🍫', 'chocolate'],
        ['☕', 'café'],
        ['🥄', 'colher'],
        ['🏠', 'casa'],
        ['🚗', 'carro'],
        ['🥕', 'cenoura'],
        ['🍄', 'cogumelo'],
        ['🐍', 'cobra'],
        ['🦉', 'coruja'],
        ['🍒', 'Cereja'],
        ['🐰', 'Coelho'],
        ['🥥', 'Coco']
      ],
      100: [
        ['🦕', 'dinossauro'],
        ['🍩', 'donut'],
        ['🎲', 'dado'],
        ['💵', 'dinheiro'],
        ['🐉', 'dragão'],
        ['💎', 'Diamante'],
        ['🦷', 'Dente']
      ],
      101: [
        ['🐿', 'esquilo'],
        ['🐘', 'elefante'],
        ['⭐', 'estrela'],
        ['🦂', 'escorpião']
      ],
      102: [
        ['👻', 'fantasma'],
        ['🐜', 'formiga'],
        ['🚀', 'foquete'],
        ['🧚', 'fada']
      ],
      103: [
        ['🦒', 'girafa'],
        ['🦍', 'gorila'],
        ['🐱', 'gato'],
        ['🐔', 'galinha'],
        ['🐬', 'golfinho']
      ],
      104: [['🚁', 'helicóptero'], ['🐹', 'hamster'], ['🦛', 'hipopótamo']],
      105: [['☃️', 'inverno'], ['⛪', 'igreja'], ['🧲', 'Imã']],
      106: [['🐗', 'javali'], ['🐊', 'jacaré'], ['📰', 'jornal']],
      107: [['🥝', 'kiwi'], ['🎤', 'karaoke']],
      108: [
        ['🐺', 'lobo'],
        ['🦁', 'leão'],
        ['🌕', 'lua'],
        ['💡', 'Lâmpada'],
        ['🦑', 'Lula']
      ],
      109: [
        ['🐵', 'macaco'],
        ['🦇', 'morcego'],
        ['🍉', 'melancia'],
        ['🍎', 'maçã'],
        ['🍓', 'morango'],
        ['🍯', 'Mel'],
        ['🥭', 'Manga'],
        ['🦟', 'mosquito']
      ],
      110: [['👃', 'nariz'], ['🌃', 'noite'], ['☁', 'nuvem'], ['🚢', 'navio']],
      111: [['👂', 'orelha'], ['👁', 'olho'], ['🐑', 'ovelha'], ['🥚', 'ovo']],
      112: [
        ['🐼', 'panda'],
        ['🐷', 'porco'],
        ['🐧', 'pinguim'],
        ['🦆', 'pato'],
        ['🐟', 'peixe'],
        ['🤡', 'palhaço'],
        ['🌶', 'Pimenta'],
        ['🦚', 'Pavão'],
        ['🥞', 'Panquecas']
      ],
      113: [['🧀', 'queijo'], ['🔲', 'quadrado'], ['🧩', 'Quebra-cabeça']],
      114: [
        ['🤖', 'robô'],
        ['🦊', 'raposa'],
        ['🐭', 'rato'],
        ['⏰', 'Relógio'],
        ['🌹', 'Rosa']
      ],
      115: [
        ['🧜', 'sereia'],
        ['🍣', 'sushi'],
        ['🍦', 'sorvete'],
        ['🐸', 'sapo'],
        ['🛰️', 'satelite'],
        ['☀️', 'Sol'],
        ['🥗', 'Salada']
      ],
      116: [
        ['🐆', 'tigre'],
        ['🐢', 'tartaruga'],
        ['🌮', 'taco'],
        ['🚆', 'trem'],
        ['☎️', 'Telefone'],
        ['☹️', 'Triste'],
        ['🌍', 'Terra']
      ],
      117: [['🦄', 'unicórnio'], ['🍇', 'uva'], ['🐻', 'urso']],
      118: [
        ['🐮', 'vaca'],
        ['🧛‍♂️', 'vampiro'],
        ['🌋', 'vulcão'],
        ['🎻', 'violino']
      ],
      119: [
        ['💊', 'warfarina'],
        ['🎛', 'wattômetro'],
        ['🇼🇫', 'Wallis e Futuna']
      ],
      121: [['💴', 'yene'], ['☯️', 'yin e yang']],
      122: [['🦓', 'zebra'], ['🧟', 'zumbi'], ['🤐', 'Zíper']]
    }
  }
};
